import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const WISHLIST_KEY = 'fivora_wishlist';
const WishlistContext = createContext(null);

const readStorage = () => {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
  catch { return []; }
};

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(readStorage);

  useEffect(() => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product) => {
    setItems((prev) =>
      prev.find((i) => i._id === product._id) ? prev : [...prev, product]
    );
  }, []);

  const removeItem = useCallback((productId) => {
    setItems((prev) => prev.filter((i) => i._id !== productId));
  }, []);

  const toggle = useCallback((product) => {
    setItems((prev) => {
      const exists = prev.find((i) => i._id === product._id);
      return exists
        ? prev.filter((i) => i._id !== product._id)
        : [...prev, product];
    });
  }, []);

  const isWished = useCallback(
    (productId) => items.some((i) => i._id === productId),
    [items]
  );

  return (
    <WishlistContext.Provider value={{ items, addItem, removeItem, toggle, isWished, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used inside WishlistProvider');
  return ctx;
};

export default WishlistContext;
